import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { TenantRoleType } from '@src/enum/tenantRoleEnum';

export type TenantUser = {
  id: number;
  family_name: string;
  first_name: string;
  avatar_url: string;
  is_admin: boolean;
  enabled: boolean;
  role: Role;
};

export type Role = {
  code: TenantRoleType;
};

export type Tenant = {
  id: number;
  name: string;
  name_kana: string;
  code: string;
  family_name: string;
  first_name: string;
  family_name_kana: string;
  first_name_kana: string;
  admin_email: string;
  phone_number: string;
  service: Service;
};

export type AuthTenant = {
  service: Service;
};

export type Service = {
  enterprise_portal: boolean;
  dx_diagnosis: boolean;
  online_community: boolean;
};

export type AuthStatusResponse = {
  is_login: boolean;
  user: TenantUser | null;
  tenant: AuthTenant | null;
  top_page_link?: string;
  first_view_link?: string;
};

export const tenantAuthStatusApiClient = {
  status: async (): Promise<ApiResult<AuthStatusResponse>> => {
    return await axiosClient.get('/tenant/auth/status');
  },
};
